import { Button, Tooltip } from "@mui/material";

const DynamicButton = ({ icon: Icon, onClick, color = "primary", tooltip }) => {
      return (
            <Tooltip title={tooltip || ""}>
                  <Button
                        variant="outlined"
                        size="small"
                        color={color}
                        onClick={onClick}
                        sx={{
                              textTransform: "none",
                              borderRadius: "8px",
                              margin: "0 4px",
                              minWidth: "36px", 
                              padding: "6px",
                        }}
                  >
                        {Icon && <Icon size={18} />}
                  </Button>
            </Tooltip>
      );
};

export default DynamicButton;
